
export const PrettyPopup = ({ popupContent }) => {

    return ( <div>
            {popupContent}
        </div> );
  };

